import { differenceBy } from 'lodash'
import { IDataForEventsIsAccepted } from '../../../actions/bookingCalendar/event/requestDataForEvents'
import { IEventsStore } from '../../events'

export default function(
  state: IEventsStore,
  action: IDataForEventsIsAccepted,
): IEventsStore {
  let { loadedDates } = state
  if (action.from) {
    loadedDates = [
      ...loadedDates,
      {
        from: action.from,
        to: action.to,
      },
    ]
  }

  return {
    ...state,
    events: [
      ...differenceBy(state.events, action.events || [], 'id'),
      ...(action.events || []),
    ],
    fullyLoaded: action.fullRange || state.fullyLoaded,
    loadedDates,
    request: {
      ...state.request,
      events: {
        ...state.request.events,
        acceptedCount: ++state.request.events.acceptedCount,
        errMessage: '',
        isLoading: false,
      },
    },
  }
}
